interface RouteEventProps<S, P> {
  type: "push" | "replace" | "goBack";
  path?: string;
  params?: P;
  state?: S;
}

const createRouteChangeEvent = <S, P>(
  routeEventProps: RouteEventProps<S, P>
) => {
  const { path, state, type, params } = routeEventProps;
  return new CustomEvent("route", { detail: { type, path, state, params } });
};

export const useAppNavigate = () => {
  const push = <S, P>(p: { to: string; state?: S; params?: P }) => {
    if (!window) return;
    const { to, params, state } = p;
    const event = createRouteChangeEvent({
      path: to,
      state,
      type: "push",
      params,
    });
    window.dispatchEvent(event);
  };

  const replace = <S, P>(p: { to: string; state?: S; params?: P }) => {
    if (!window) return;
    const { to, params, state } = p;
    const event = createRouteChangeEvent({
      path: to,
      state,
      type: "replace",
      params,
    });
    window.dispatchEvent(event);
  };

  const goBack = () => {
    if (!window) return;
    const event = createRouteChangeEvent({ type: "goBack" });
    window.dispatchEvent(event);
  };

  return {
    push,
    replace,
    goBack,
  };
};
